import React, { useState } from 'react'
import { Cards } from "../../../core/components/editor/styled/fragments";
import Label from 'core/components/label/Label';
import styled from "styled-components";
import TypographyView from 'common/views/typographyView/Typography.view';
import { TextInputView } from 'common/views/textInput/TextInput.view';
import getAllCountryNames from "./utils/countryName";
import { DropdownSelectView } from 'common/views/dropdownSelect/DropdownSelect.view';
import { MenuItem, Tooltip } from '@blueprintjs/core';
import { ButtonView } from 'common/views/button/Button.view';
import { BlockView } from 'common/views/block/BlockView.view';
import { BoxView } from 'common/views/box/Box.view';
import IconView from 'common/views/icon/Icon.view';
import { validateCardNumber } from './utils/ValidateCardNumber';
import { CheckBoxView } from 'common/views/checkbox/Checkbox.view';

const StyledDiv = styled.div`
	 {
		display: flex;
		justify-content: flex-start;
		padding: 0.5em;
		width: 65%;
		flex-flow: column wrap;
		& > input {
			height:40px;
		}
	}
`;

const StyledDropdownDiv = styled.div`
	 {
		display: block;
		justify-content: flex-start;
		padding: 0.5em;
		width: 65%;
		flex-flow: column wrap;
		margin-bottom: 12px;
        margin-left: 12px;
		& > input {
			height:40px;
		}
	}
`;

const StyledSecurityDiv = styled.div`
{
		display: block;
		justify-content: flex-start;
		padding: 0.5em;
		width: 65%;
		flex-flow: column wrap;
		margin-bottom: 12px
		& > input {
			height:40px;
		}
	}
`;

const ErrorMessage = styled.span`
	color: #f24441;
    font-size: 12px;
`;

const CardErrorMessage = styled.span`
    margin-left: 14px;
	color: #f24441;
    font-size: 12px;
`;

const CartCheckoutDetailsForm = (props) => {
    const [userDetails, setUserDetails] = useState(props.cartUserDetails || {
        cardNumber: "",
        expiry_mm: "",
        expiry_yy: "",
        security: null,
        name: "",
        address_one: "",
        address_two: "",
        state: "",
        city: "",
        zipCode: "",
        country: "United States",
        errorMessage: "",
        allCountryOptions: getAllCountryNames(),
    });

    const discountResponse = props.discountResponse || 0;
    const discount = discountResponse && discountResponse['discount'] || null;
    const { value } = discount ? discount : { value: 0 };

    const [errorMessage, setErrorMessage] = useState("");
    const [cardErrorMessage, setCardErrorMessage] = useState("");
    const [sameAsShippingAddress, setSameAsShippingAddress] = useState(false);

    const { cardNumber, expiry_mm, expiry_yy, security, name,
        address_one, address_two, city, state, zipCode, country, allCountryOptions } = userDetails;

    const validateExpiry = (name: string, value?: string) => {
        if ((name === "expiry_yy")) {
            if (value === new Date().getFullYear().toString() && userDetails.expiry_mm && Number(userDetails.expiry_mm) < new Date().getMonth() + 1) {
                setErrorMessage("Invalid expiry Year");

            } else {
                setErrorMessage("");
            }
        }
        if ((name === "expiry_mm")) {
            if (value < (new Date().getMonth() + 1).toString() && userDetails.expiry_yy && userDetails.expiry_yy === new Date().getFullYear().toString()) {
                setErrorMessage("Invalid expiry month");

            } else {
                setErrorMessage("");
            }
        }
    }

    const handleCardNumber = (name: string, value: string) => {

        if (!isNaN(Number(value))) {
            setUserDetails({
                ...userDetails,
                [name]: value,
            });
            setCardErrorMessage("")
        }
    }

    const handleSecurityNumber = (name: string, value: string) => {

        if (!isNaN(Number(value)) && value.length < 4) {
            setUserDetails({
                ...userDetails,
                [name]: value,
            });
        }
    }

    const handleChange = (name: string, value?: string) => {
        if (name === "expiry_mm" || name === "expiry_yy") {
            validateExpiry(name, value);
        }
        setUserDetails({
            ...userDetails,
            [name]: value,
        });
    };

    const handleSameAsShippingAddress = () => {
        setSameAsShippingAddress(!sameAsShippingAddress);
        if (!sameAsShippingAddress) {
            setUserDetails({
                ...userDetails, ...props.shippableUserDetails
            })
        } else {
            setUserDetails({
                ...userDetails
            })
        }
    }

    const calculateTotal = () => {
        const price = props.cartItems.reduce((total, item) => {
            const { courseQuantity: quantity = 0 } = props.quantityInCart.find(obj => obj.courseId === item.id) || {};
            const itemPrice = item.variants.reduce((variantTotal, variant) => variantTotal + quantity * variant.price, 0);
            return total + itemPrice;
        }, 0);

        return price;
    }

    const isFormValid = () => {
        const requiredFields = [
            cardNumber, city, country, security,
            expiry_mm, expiry_yy, name, state, zipCode
        ];
        return requiredFields.every(field => field) && !errorMessage;
    };

    return (
        <React.Fragment>
            {((calculateTotal() - value) > 0) ? (
                <React.Fragment>
                    <BoxView viewKey='userDetails-form'>
                        <TypographyView viewKey="field.required" >
                            <Label k={"user.required.filled"} v={"*All fields are required*"} />
                        </TypographyView>
                        <BoxView viewKey='cardDetails-box'>
                            <StyledDiv>
                                <TextInputView
                                    viewKey="user.card.number"
                                    type="text"
                                    placeholder="Card Number"
                                    value={cardNumber}
                                    onChange={(value: string) => handleCardNumber("cardNumber", value)}
                                />
                                <Cards />
                            </StyledDiv>
                            <CardErrorMessage>{cardErrorMessage}</CardErrorMessage>
                            <StyledDropdownDiv>
                                <Label k="Expiration" v={"Expiration(mm/yyyy): "} />
                                <DropdownSelectView
                                    viewKey="months"
                                    items={['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']}
                                    popOverContentStyles={{
                                        maxHeight: "200px",
                                        overflowY: "scroll"
                                    }}
                                    itemRenderer={(value: any, { handleSelect }) => {
                                        return (
                                            <MenuItem
                                                key={value}
                                                text={<Label k={value} v={value} args={{ value }} />}
                                                onClick={handleSelect}
                                            />
                                        );
                                    }}
                                    onChange={(value: string) => handleChange("expiry_mm", value)}
                                >
                                    <Label k="Month" v={expiry_mm} args={{ value: expiry_mm }} />
                                </DropdownSelectView>
                                <DropdownSelectView
                                    viewKey="Year"
                                    items={Array.from({ length: 50 }, (_, i) => (new Date().getFullYear() + i).toString())}
                                    popOverContentStyles={{
                                        maxHeight: "200px",
                                        overflowY: "scroll"
                                    }}
                                    itemRenderer={(value: any, { handleSelect }) => {
                                        return (
                                            <MenuItem
                                                key={value}
                                                text={<Label k={value} v={value} args={{ value }} />}
                                                onClick={handleSelect}
                                            />
                                        );
                                    }}
                                    onChange={(value: string) => handleChange("expiry_yy", value)}
                                >
                                    <Label k="Year" v={expiry_yy} args={{ value: expiry_yy }} />
                                </DropdownSelectView>
                                <ErrorMessage> {errorMessage}</ErrorMessage>
                            </StyledDropdownDiv>
                            <StyledSecurityDiv>
                                <TextInputView
                                    viewKey="user.card.security"
                                    type="text"
                                    placeholder="Security"
                                    value={security}
                                    onChange={(value: string) => handleSecurityNumber("security", value)}
                                />
                                <Tooltip content="This is a three digit number on back of your card">
                                    <IconView icon="help" viewKey="help" />
                                </Tooltip>
                            </StyledSecurityDiv>
                        </BoxView>
                        <TypographyView viewKey="user.billing.information" >
                            <Label k={"billing.information"} v={"Billing Information"} />
                        </TypographyView>
                        {(props.shippableUserDetails && props.shippableUserDetails.name) ? (
                            <CheckBoxView
                                viewKey={'cart.same.shipping.address'}
                                value={sameAsShippingAddress}
                                onChange={() => handleSameAsShippingAddress()}
                                label={<Label k="cart.items.sameAsShippingAddress" v="Same as Shipping Address" />}
                            />) : null}
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.name"
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(value: string) => handleChange("name", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.address.one"
                                type="text"
                                placeholder="Address(1)"
                                value={address_one}
                                onChange={(value: string) => handleChange("address_one", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.address.two"
                                type="text"
                                placeholder="Address(2)"
                                value={address_two}
                                onChange={(value: string) => handleChange("address_two", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.state"
                                type="text"
                                placeholder="State/Province"
                                value={state}
                                onChange={(value: string) => handleChange("state", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.city"
                                type="text"
                                placeholder="City"
                                value={city}
                                onChange={(value: string) => handleChange("city", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <TextInputView
                                viewKey="user.zipCode"
                                type="text"
                                placeholder="Zip/Postal Code"
                                value={zipCode}
                                onChange={(value: string) => handleChange("zipCode", value)}
                            />
                        </StyledDiv>
                        <StyledDiv>
                            <DropdownSelectView
                                viewKey="countries"
                                items={allCountryOptions}
                                popOverContentStyles={{
                                    maxHeight: "200px",
                                    overflowY: "scroll"
                                }}
                                itemRenderer={(value: any, { handleSelect }) => {
                                    return (
                                        <MenuItem
                                            key={value}
                                            text={<Label k={value} v={value} args={{ value }} />}
                                            onClick={handleSelect}
                                        />
                                    );
                                }}
                                onChange={(value: string) => handleChange("country", value)}
                            >
                                <Label k="Country" v={userDetails.country || "United States"} args={{ value: userDetails.country }} />
                            </DropdownSelectView>
                        </StyledDiv>
                        {isFormValid() ? (
                            <BlockView viewKey={"cart.summary.continue"}>
                                <ButtonView viewKey={"cart-continue"} onClick={() => {
                                    if (validateCardNumber(cardNumber)) {
                                        props.handleContinueClick();
                                        props.actions.saveCartUserDetails(userDetails);
                                    } else {
                                        setCardErrorMessage("Invalid Card Details");
                                    }

                                }} >Continue</ButtonView>
                            </BlockView>
                        ) : ""}
                    </BoxView>
                </React.Fragment>
            ) : null}
        </React.Fragment>
    )
}

export default CartCheckoutDetailsForm;




// WEBPACK FOOTER //
// ./src/panels/catalog/cart/CartCheckoutDetailsForm.tsx